import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Button, Table } from 'reactstrap';
import { JhiItemCount, JhiPagination, Translate, getPaginationState } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSort, faSortDown, faSortUp } from '@fortawesome/free-solid-svg-icons';
import { ASC, DESC, ITEMS_PER_PAGE, SORT } from 'app/shared/util/pagination.constants';
import { overridePaginationStateWithQueryParams } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities } from './method-of-travel-to-work.reducer';

export const MethodOfTravelToWork = () => {
  const dispatch = useAppDispatch();

  const pageLocation = useLocation();
  const navigate = useNavigate();

  const [paginationState, setPaginationState] = useState(
    overridePaginationStateWithQueryParams(getPaginationState(pageLocation, ITEMS_PER_PAGE, 'id'), pageLocation.search),
  );

  const methodOfTravelToWorkList = useAppSelector(state => state.methodOfTravelToWork.entities);
  const loading = useAppSelector(state => state.methodOfTravelToWork.loading);
  const totalItems = useAppSelector(state => state.methodOfTravelToWork.totalItems);

  const getAllEntities = () => {
    dispatch(
      getEntities({
        page: paginationState.activePage - 1,
        size: paginationState.itemsPerPage,
        sort: `${paginationState.sort},${paginationState.order}`,
      }),
    );
  };

  const sortEntities = () => {
    getAllEntities();
    const endURL = `?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`;
    if (pageLocation.search !== endURL) {
      navigate(`${pageLocation.pathname}${endURL}`);
    }
  };

  useEffect(() => {
    sortEntities();
  }, [paginationState.activePage, paginationState.order, paginationState.sort]);

  useEffect(() => {
    const params = new URLSearchParams(pageLocation.search);
    const page = params.get('page');
    const sort = params.get(SORT);
    if (page && sort) {
      const sortSplit = sort.split(',');
      setPaginationState({
        ...paginationState,
        activePage: +page,
        sort: sortSplit[0],
        order: sortSplit[1],
      });
    }
  }, [pageLocation.search]);

  const sort = p => () => {
    setPaginationState({
      ...paginationState,
      order: paginationState.order === ASC ? DESC : ASC,
      sort: p,
    });
  };

  const handlePagination = currentPage =>
    setPaginationState({
      ...paginationState,
      activePage: currentPage,
    });

  const handleSyncList = () => {
    sortEntities();
  };

  const getSortIconByFieldName = (fieldName: string) => {
    const sortFieldName = paginationState.sort;
    const order = paginationState.order;
    if (sortFieldName !== fieldName) {
      return faSort;
    }
    return order === ASC ? faSortUp : faSortDown;
  };

  return (
    <div>
      <h2 id="method-of-travel-to-work-heading" data-cy="MethodOfTravelToWorkHeading">
        <Translate contentKey="apiLocationApp.methodOfTravelToWork.home.title">Method Of Travel To Works</Translate>
        <div className="d-flex justify-content-end">
          <Button className="me-2" color="info" onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} />{' '}
            <Translate contentKey="apiLocationApp.methodOfTravelToWork.home.refreshListLabel">Refresh List</Translate>
          </Button>
          <Link
            to="/method-of-travel-to-work/new"
            className="btn btn-primary jh-create-entity"
            id="jh-create-entity"
            data-cy="entityCreateButton"
          >
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <Translate contentKey="apiLocationApp.methodOfTravelToWork.home.createLabel">Create new Method Of Travel To Work</Translate>
          </Link>
        </div>
      </h2>
      <div className="table-responsive">
        {methodOfTravelToWorkList && methodOfTravelToWorkList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th className="hand" onClick={sort('id')}>
                  <Translate contentKey="apiLocationApp.methodOfTravelToWork.id">ID</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('id')} />
                </th>
                <th className="hand" onClick={sort('geographicLevel')}>
                  <Translate contentKey="apiLocationApp.methodOfTravelToWork.geographicLevel">Geographic Level</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('geographicLevel')} />
                </th>
                <th className="hand" onClick={sort('date')}>
                  <Translate contentKey="apiLocationApp.methodOfTravelToWork.date">Date</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('date')} />
                </th>
                <th className="hand" onClick={sort('geography')}>
                  <Translate contentKey="apiLocationApp.methodOfTravelToWork.geography">Geography</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('geography')} />
                </th>
                <th className="hand" onClick={sort('geographyCode')}>
                  <Translate contentKey="apiLocationApp.methodOfTravelToWork.geographyCode">Geography Code</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('geographyCode')} />
                </th>
                <th className="hand" onClick={sort('totalAllUsualResidents')}>
                  <Translate contentKey="apiLocationApp.methodOfTravelToWork.totalAllUsualResidents">Total All Usual Residents</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('totalAllUsualResidents')} />
                </th>
                <th className="hand" onClick={sort('workMainlyAtHome')}>
                  <Translate contentKey="apiLocationApp.methodOfTravelToWork.workMainlyAtHome">Work Mainly At Home</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('workMainlyAtHome')} />
                </th>
                <th className="hand" onClick={sort('underground')}>
                  <Translate contentKey="apiLocationApp.methodOfTravelToWork.underground">Underground</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('underground')} />
                </th>
                <th className="hand" onClick={sort('train')}>
                  <Translate contentKey="apiLocationApp.methodOfTravelToWork.train">Train</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('train')} />
                </th>
                <th className="hand" onClick={sort('bus')}>
                  <Translate contentKey="apiLocationApp.methodOfTravelToWork.bus">Bus</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('bus')} />
                </th>
                <th className="hand" onClick={sort('taxi')}>
                  <Translate contentKey="apiLocationApp.methodOfTravelToWork.taxi">Taxi</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('taxi')} />
                </th>
                <th className="hand" onClick={sort('motorcycle')}>
                  <Translate contentKey="apiLocationApp.methodOfTravelToWork.motorcycle">Motorcycle</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('motorcycle')} />
                </th>
                <th className="hand" onClick={sort('drivingCarVan')}>
                  <Translate contentKey="apiLocationApp.methodOfTravelToWork.drivingCarVan">Driving Car Van</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('drivingCarVan')} />
                </th>
                <th className="hand" onClick={sort('passengerCarVan')}>
                  <Translate contentKey="apiLocationApp.methodOfTravelToWork.passengerCarVan">Passenger Car Van</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('passengerCarVan')} />
                </th>
                <th className="hand" onClick={sort('bicycle')}>
                  <Translate contentKey="apiLocationApp.methodOfTravelToWork.bicycle">Bicycle</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('bicycle')} />
                </th>
                <th className="hand" onClick={sort('onFoot')}>
                  <Translate contentKey="apiLocationApp.methodOfTravelToWork.onFoot">On Foot</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('onFoot')} />
                </th>
                <th className="hand" onClick={sort('otherMethod')}>
                  <Translate contentKey="apiLocationApp.methodOfTravelToWork.otherMethod">Other Method</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('otherMethod')} />
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {methodOfTravelToWorkList.map((methodOfTravelToWork, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td>
                    <Button tag={Link} to={`/method-of-travel-to-work/${methodOfTravelToWork.id}`} color="link" size="sm">
                      {methodOfTravelToWork.id}
                    </Button>
                  </td>
                  <td>
                    <Translate contentKey={`apiLocationApp.GeographicLevel.${methodOfTravelToWork.geographicLevel}`} />
                  </td>
                  <td>{methodOfTravelToWork.date}</td>
                  <td>{methodOfTravelToWork.geography}</td>
                  <td>{methodOfTravelToWork.geographyCode}</td>
                  <td>{methodOfTravelToWork.totalAllUsualResidents}</td>
                  <td>{methodOfTravelToWork.workMainlyAtHome}</td>
                  <td>{methodOfTravelToWork.underground}</td>
                  <td>{methodOfTravelToWork.train}</td>
                  <td>{methodOfTravelToWork.bus}</td>
                  <td>{methodOfTravelToWork.taxi}</td>
                  <td>{methodOfTravelToWork.motorcycle}</td>
                  <td>{methodOfTravelToWork.drivingCarVan}</td>
                  <td>{methodOfTravelToWork.passengerCarVan}</td>
                  <td>{methodOfTravelToWork.bicycle}</td>
                  <td>{methodOfTravelToWork.onFoot}</td>
                  <td>{methodOfTravelToWork.otherMethod}</td>
                  <td className="text-end">
                    <div className="btn-group flex-btn-group-container">
                      <Button
                        tag={Link}
                        to={`/method-of-travel-to-work/${methodOfTravelToWork.id}`}
                        color="info"
                        size="sm"
                        data-cy="entityDetailsButton"
                      >
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`/method-of-travel-to-work/${methodOfTravelToWork.id}/edit?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`}
                        color="primary"
                        size="sm"
                        data-cy="entityEditButton"
                      >
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button
                        onClick={() =>
                          (window.location.href = `/method-of-travel-to-work/${methodOfTravelToWork.id}/delete?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`)
                        }
                        color="danger"
                        size="sm"
                        data-cy="entityDeleteButton"
                      >
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Delete</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="apiLocationApp.methodOfTravelToWork.home.notFound">No Method Of Travel To Works found</Translate>
            </div>
          )
        )}
      </div>
      {totalItems ? (
        <div className={methodOfTravelToWorkList && methodOfTravelToWorkList.length > 0 ? '' : 'd-none'}>
          <div className="justify-content-center d-flex">
            <JhiItemCount page={paginationState.activePage} total={totalItems} itemsPerPage={paginationState.itemsPerPage} i18nEnabled />
          </div>
          <div className="justify-content-center d-flex">
            <JhiPagination
              activePage={paginationState.activePage}
              onSelect={handlePagination}
              maxButtons={5}
              itemsPerPage={paginationState.itemsPerPage}
              totalItems={totalItems}
            />
          </div>
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

export default MethodOfTravelToWork;
